import React, { useState, useEffect, useRef } from 'react'
import * as styles from './nav.module.css'
import { Link } from 'gatsby'
import Icon from '../icons/icon/'
import ThemeLogo from '../themeLogo'
import { getLinkPath } from '../../helpers'

const MobileMenu = ({ isPartiallyActive, homePageSlug, links, ctaLink }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)

  const node = useRef()

  const handleClick = e => {
    // if we are clicking inside the mobile menu, do nothing
    if (node.current.contains(e.target)) {
      return null
    }

    // if we are clicking outside the mobile menu, close the menu
    setMenuOpen(false)
  }

  useEffect(() => {
    // add when mounted
    document.addEventListener('mousedown', handleClick)
    // return function to be called when unmounted
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [])

  return (
    <div ref={node} className={styles.mobileNav}>
      <div className={styles.mobileNavHeader}>
        <div
          className={styles.menuButton}
          onClick={() => setMenuOpen(!isMenuOpen)}
          role="button"
          tabIndex="0"
          onKeyDown={() => setMenuOpen(!isMenuOpen)}
        >
          <Icon icon="Menu" />
        </div>
        <Link to={homePageSlug} className={styles.logoMark}>
          <ThemeLogo />
        </Link>
        <div style={{ width: '24px' }} />
      </div>
      {isMenuOpen && (
        <div className={styles.mobileNavLinks}>
          {links.map(link => (
            <Link
              key={link.title}
              getProps={isPartiallyActive}
              to={getLinkPath(link)}
            >
              {link.title}
            </Link>
          ))}

          {ctaLink && (
            <Link getProps={isPartiallyActive} to={getLinkPath(ctaLink)}>
              {ctaLink.title}
            </Link>
          )}
        </div>
      )}
    </div>
  )
}

export default MobileMenu
